<template>
    <div class="modal-open">
        <div class="modal modal-opened" tabindex="-1" role="dialog" aria-hidden="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-rounded">
                    <div class="row">
                        <div class="col-md-12 text-center centered-content" v-if="submitted">
                            <p>{{'contact_us.congrats' | trans}}</p>
                        </div>
                        <div class="col-md-12" v-if="!submitted">
                            <form enctype="multipart/form-data" novalidate>
                                <div class="modal-header">
                                    <h2 class="modal-title">{{'contact_us.header' | trans}}</h2>
                                </div>
                                <div class="modal-body">
                                    <loader v-if="!loaded" class="table-loader"></loader>
                                    <div class="alert alert-danger" role="alert" v-if="errors.has('server')">
                                        {{errors.first('server')}}
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <label for="name">{{'contact_us.labels.name'
                                                | trans}}</label>
                                            <input id="name" type="text" class="form-control" name="name"
                                                   :class="{'is-invalid': errors.has('name')}"
                                                   v-validate="'required|alpha_spaces|max:255'" v-model="form.name"
                                                   data-vv-validate-on="none"
                                                   :data-vv-as="'contact_us.labels.name' | trans">
                                            <span class="invalid-feedback" v-if="errors.has('name')">
                                               {{ errors.first('name') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <label for="email">{{'validation.attributes.email' | trans}}</label>
                                            <input id="email" type="text" class="form-control" name="email"
                                                   v-model="form.email" :class="{'is-invalid': errors.has('email')}"
                                                   v-validate="'required|email|max:255'" data-vv-validate-on="none"
                                                   :data-vv-as="'validation.attributes.email' | trans">
                                            <span class="invalid-feedback" v-if="errors.has('email')">
                                                {{ errors.first('email') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <label for="message">{{'contact_us.labels.message' | trans}}</label>
                                            <textarea name="message" class="form-control" id="message"
                                                      v-model="form.message"
                                                      :class="{'is-invalid': errors.has('message')}"
                                                      v-validate="'required'" data-vv-validate-on="none"
                                                      :data-vv-as="'contact_us.labels.message' | trans"></textarea>
                                            <span class="invalid-feedback" v-if="errors.has('message')">
                                                {{ errors.first('message') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-md-4">
                                            <label for="captcha"
                                                   class="col-form-label text-md-right">
                                                {{ 'contact_us.labels.captcha' | trans }}
                                            </label>
                                        </div>
                                        <div class="col-md-8 capcha-cell">
                                            <img :src="image" alt="Captcha">
                                        </div>

                                    </div>

                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <label for="captcha">{{'contact_us.labels.captcha'
                                                | trans}}</label>
                                            <input id="captcha" type="text" class="form-control" name="captcha"
                                                   :class="{'is-invalid': errors.has('captcha')}"
                                                   v-validate="'required|alpha_num|max:255'" v-model="form.captcha"
                                                   data-vv-validate-on="none"
                                                   :data-vv-as="'contact_us.labels.captcha' | trans">
                                            <span class="invalid-feedback" v-if="errors.has('captcha')">
                                               {{ errors.first('captcha') }}
                                            </span>
                                        </div>
                                    </div>


                                </div>

                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success active" @click.prevent="send()"
                                            :disabled="disabled">
                                        {{'contact_us.buttons.send' | trans}}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
  import isObject from 'lodash/isObject';
  import lang from '../../../lang/translator';
  import Loader from '../../loader/components/Loader';
  import axios from 'axios';

  export default {
    data() {
      return {
        form: {
          name: null,
          email: null,
          message: null,
          captcha: null,
          captcha_key: null,
        },
        image: null,
        loaded: false,
        disabled: false,
        submitted: false,
      };
    },
    components: {Loader},
    metaInfo: {
      title: lang.get('contact_us.header'),
    },
    methods: {
      send: async function() {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }
        try {
          let isSaved = await axios.post('/contact-us', this.form);
          this.submitted = true;
        } catch ({response}) {
          let errors = response.data.errors;
          if (isObject(errors)) {
            if (errors.message) {
              this.errors.add('server', errors.message);
            } else {
              for (let key of Object.keys(errors)) {
                let {message} = errors[key];
                this.errors.add(key, message);
              }
            }
          }
          this.disabled = false;
        }
      },
    },
    async created() {
      let response = await axios.get('/contact-us/captcha');
      let {data} = response.data;
      this.image = data.img;
      this.form.captcha_key = data.key;
      this.loaded = true;
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/contactUs/components/ContactUsForm.vue